import React from "react";
import { Redirect } from "react-router-dom";
import { Alert, Row, Col, Form, Button, FormControl, Modal } from "react-bootstrap";
import {
    fetchSurvey,
    putSurvey,
    postSurvey,
    deleteSurvey,
    fetchSurveyWhereOption,
    fetchSurveyWhenOption,
    fetchSurveyWhere,
    fetchSurveyWhen,
    deleteSurveyWhen,
    deleteSurveyWhere,
    postSurveyWhen,
    postSurveyWhere,
    postSurveyWhereOption,
    postSurveyWhenOption
} from "./services/DataService";
import DeleteAlert from "./components/DeleteAlert";
import "./style/form.scss";
class AddPas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: "",
            student_group_list: ["Select a type", "yes, at WWU", "yes, at Whatcome", "yes, at an other School ", "No"],
            student_db_list: [null, "wwu", "oth", "wcc", "no"],
            age_type: ["Select a type", "under 16", "16 - 18", "19 - 21", "22 - 25", "26 - 30", "over 30"],
            age_db_type: [null, "kid", "high", "stud", "grad", "adult", "old"],
            datetime: new Date(),
            test: "",
            selectedWhen: [],
            selectedWhere: [],
            whenOption: [],
            whereOption: [],
            displayWhereOption: [],
            displayWhenOption: [],
            addWhere: false,
            addWhen: false,
            display:"",
            label:""
        };
        this.onStatusChange = this.onStatusChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onDeleteCallback = this.onDeleteCallback.bind(this);
        this.submitCallback = this.submitCallback.bind(this);
        this.surveyfun = this.surveyfun.bind(this);
    }

    componentDidMount() {
        Promise.all([fetchSurveyWhereOption(), fetchSurveyWhenOption()]).then(([whereOption, whenOption]) => {
            var displayWhenOption = whenOption.map(option => option.display)
            var displayWhereOption = whereOption.map(option => option.display)
            this.setState({
                whereOption: whereOption,
                whenOption: whenOption,
                displayWhereOption,
                displayWhenOption
            })
        })
        if (this.props.match.params.id) {
            Promise.all([fetchSurvey(this.props.match.params.id), fetchSurveyWhere(this.props.match.params.id), fetchSurveyWhen(this.props.match.params.id)])
                .then(([survey, where, when]) => {
                    var age_group = this.state.age_type[this.state.age_db_type.indexOf(survey.age_group)]
                    var student = this.state.student_group_list[this.state.student_db_list.indexOf(survey.student)]
                    var selectedWhen = [];
                    var selectedWhere = [];
                    if (when != null) {
                        selectedWhen = this.state.whenOption.filter(item => when.some(selected => selected.surveywhen_id === item.id)).map(item => item.display)
                    }
                    if (where != null) {
                        selectedWhere = this.state.whereOption.filter(item => where.some(selected => selected.surveywhere_id === item.id)).map(item => item.display)
                    }
                    this.setState({ ...survey, student: student, age_group: age_group, selectedWhere: selectedWhere, selectedWhen: selectedWhen })
                }
                );
        }
    }

    onStatusChange(e) {
        this.setState({ status: e.target.value });
    }

    surveyfun = (id) => {
        console.log("called?", id)
        this.state.whenOption.map(item => {
            if (this.state.selectedWhen.includes(item.display)) {
                var obj = {
                    survey_id: id,
                    surveywhen_id: item.id
                }
                postSurveyWhen(id, obj).then(this.submitCallback);
            }
            return 0
        })
        this.state.whereOption.map(item => {
            if (this.state.selectedWhere.includes(item.display)) {
                var obj = {
                    survey_id: id,
                    surveywhere_id: item.id
                }
                console.log(obj)
                postSurveyWhere(id, obj).then(this.submitCallback);
            }
            return 0
        })
    }

    submitCallback() {
        this.setState({
            alert: (
                <Alert variant="secondary">
                    <Alert.Heading>Submission Successful</Alert.Heading>
                    <hr />
                    <p>The psa has been added/updated.</p>
                    <div className="d-flex justify-content-end">
                        <Button
                            onClick={() => this.setState({ redirect: "/survey" })}
                            variant="outline-secondary"
                        >
                            Close
                        </Button>
                    </div>
                </Alert>
            ),
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        this.setState({ validated: true });
        var isValid = form.checkValidity();
        var survey = {};
        survey.id = parseInt(this.state.id);
        survey.name = this.state.name;
        survey.email = this.state.email;
        survey.student = this.state.student_db_list[this.state.student_group_list.indexOf(this.state.student)];
        survey.age_group = this.state.age_db_type[this.state.age_type.indexOf(this.state.age_group)];
        survey.genres = this.state.genres;
        survey.artists = this.state.artists;
        survey.comments = this.state.comments;
        if (isValid) {
            if (this.props.match.params.id) {
                deleteSurveyWhere(survey.id).then(deleteSurveyWhen(survey.id)).then(putSurvey(survey.id, survey).then(this.surveyfun(parseInt(survey.id))))
            } else {
                postSurvey(survey).then(id => this.surveyfun(parseInt(id)));
            }
        }
    };

    onDelete() {
        this.setState({ deleteAlert: true });
    }

    onDeleteCallback() {
        this.setState({ deleteAlert: false, redirect: "/survey" });
    }

    onChange = (e) => this.setState({ [e.target.name]: !e.target.value });

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />;
        }
        if (this.state.alert) {
            return this.state.alert;
        }
        let deleteAlert;
        if (this.state.deleteAlert) {
            deleteAlert = (
                <DeleteAlert
                    onConfirm={() => {
                        deleteSurvey(this.state.id).then(this.onDeleteCallback);
                    }}
                    onCancel={() => this.setState({ deleteAlert: false })}
                />
            );
        }
        let deleteButton;
        if (this.props.match.params.id) {
            deleteButton = (
                <div className="d-flex justify-content-center">
                    <Button
                        variant="danger"
                        className="btn-delete"
                        onClick={this.onDelete}
                    >
                        Delete
                    </Button>
                </div>
            );
        }
        const dataType = ["name", "email", "genres", "artists", "comments"];
        const formdata = dataType.map(data => (
            <>
                < Form.Label column sm="3" className="d-flex align-items-center flex-row-reverse  mb-2" >
                    {data.charAt(0).toUpperCase() + data.substring(1).replace('_', ' ')}
                </Form.Label >
                <Col sm="8">
                    <Form.Control
                        required
                        name={data.charAt(0).toUpperCase() + data.substring(1).replace('_', ' ')}
                        placeholder={data.charAt(0).toUpperCase() + data.substring(1).replace('_', ' ')}
                        onChange={event => this.setState({ [data]: event.target.value })}
                        value={this.state[data] || ""}
                        className="mb-0"
                    />
                    <Form.Control.Feedback type="invalid">
                        Please provide a name of the psa.
                    </Form.Control.Feedback>
                </Col>
            </>

        ))
        let optionModule;
        if (this.state.addWhen || this.state.addWhere) {
            optionModule = (
                <Modal show={true} classname="addWhen" >
                    <Modal.Header>
                        <Modal.Title>Add {this.props.addWhen ? "when" : "where"} label Option</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="form" noValidate>
                            <Form.Group as={Row}>
                                <Form.Label column sm="1">
                                    Label
                                </Form.Label>
                                <Col sm="3">
                                    <Form.Control
                                        required
                                        type="text"
                                        name="label"
                                        onChange={event => this.setState({ label: event.target.value })}
                                        value={this.state.label || ""}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a label.
                                    </Form.Control.Feedback>
                                </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                <Form.Label column sm="1">
                                    Display
                                </Form.Label>
                                <Col sm="3">
                                    <Form.Control
                                        required
                                        type="text"
                                        name="display"
                                        onChange={event => this.setState({ display: event.target.value })}
                                        value={this.state.display || ""}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a display.
                                    </Form.Control.Feedback>
                                </Col>
                                </Form.Group>
                                <Form.Group as={Row}>
                                <Col sm="2" className="pt-3">
                                    <Button variant="primary"
                                    style={{ width: "60%"}}
                                     onClick={() => {
                                        var data ;
                                        if(this.state.addWhen){
                                            data = {
                                                when:this.state.label,
                                                display:this.state.display
                                            }
                                            console.log(data)
                                            postSurveyWhenOption(data).then(this.submitCallback)
                                        }else{
                                            data = {
                                                where:this.state.label,
                                                display:this.state.display
                                            }
                                            postSurveyWhereOption(data).then(this.submitCallback)
                                        }
                                        this.setState({ addWhen: false, addwhere:false })
                                    }}
                                     className="btn-submit">
                                        Add
                                    </Button>
                                </Col>
                                <Col sm="2"className="pt-3">
                                    <Button variant="primary" 
                                     style={{ width: "60%"}}
                                    onClick={() => this.setState({ addWhen: false, addwhere:false })}
                                    className="btn-submit" >
                                        Close
                                    </Button>
                                </Col>
                                </Form.Group>
                        </Form>
                    </Modal.Body>
                </Modal>
            )
        }
        return (
            <div>
                {deleteAlert}
                < div className="form-title" >
                    {this.props.match.params.id ? "Edit" : "Add"} a Survey
                </div >
                <Form
                    className="form"
                    noValidate
                    validated={this.state.validated}
                    onSubmit={this.handleSubmit}
                >
                    <Form.Group as={Row}>
                        {formdata}
                        <Form.Label column sm="3" className="d-flex align-items-center flex-row-reverse mb-2">
                            Age Group
                        </Form.Label>
                        <Col sm="8">
                            <FormControl
                                required
                                as="select"
                                name="type"
                                onChange={event => this.setState({ age_group: event.target.value })}
                                value={this.state.age_group}
                            >
                                {this.state.age_type.map((type, index) => {
                                    return (
                                        <option value={type} key={index}>
                                            {type}
                                        </option>
                                    );
                                })}
                            </FormControl>
                        </Col>
                        <Form.Label column sm="3" className="d-flex align-items-center flex-row-reverse mb-2">
                            Student
                        </Form.Label>
                        <Col sm="8">
                            <FormControl
                                required
                                as="select"
                                name="type"
                                onChange={event => this.setState({ student: event.target.value })}
                                value={this.state.student}
                            >
                                {this.state.student_group_list.map((type, index) => {
                                    return (
                                        <option value={type} key={index}>
                                            {type}
                                        </option>
                                    );
                                })}
                            </FormControl>
                        </Col>
                        <Form.Label column sm="3" className="d-flex align-items-center flex-row-reverse mb-2">
                            When
                        </Form.Label>
                        <Col sm="7">
                            <FormControl
                                required
                                multiple
                                as="select"
                                name="type"
                                onChange={e => this.setState({ selectedWhen: [].slice.call(e.target.selectedOptions).map(item => item.value) })}
                                value={this.state.selectedWhen}
                            >
                                {this.state.displayWhenOption.map((display, index) => {
                                    return (
                                        <option value={display} key={index}>
                                            {display}
                                        </option>
                                    );
                                })}
                            </FormControl>
                        </Col>
                        <Col sm="1" classname="">
                            <Button
                                variant="primary"
                                className="glyphicon glyphicon-plus btn-add d-flex align-items-center mt-4 "
                                onClick={() => this.setState({ addWhen: true })}
                            ></Button>
                        </Col>
                        <Form.Label column sm="3" className="d-flex align-items-center flex-row-reverse mb-2">
                            Where
                        </Form.Label>
                        <Col sm="7">
                            <FormControl
                                required
                                multiple
                                as="select"
                                name="type"
                                onChange={e => this.setState({ selectedWhere: [].slice.call(e.target.selectedOptions).map(item => item.value) })}
                                value={this.state.selectedWhere}
                            >
                                {this.state.displayWhereOption.map((display, index) => {
                                    return (
                                        <option value={display} key={index}>
                                            {display}
                                        </option>
                                    );
                                })}
                            </FormControl>
                        </Col>
                        <Col sm="1" classname="">
                            <Button
                                variant="primary"
                                onClick={() => this.setState({ addWhere: true })}
                                className="glyphicon glyphicon-plus btn-add d-flex align-items-center mt-4 "
                            ></Button>
                        </Col>

                    </Form.Group>
                    {optionModule}
                    <div className="d-flex justify-content-center">
                        <div style={{ width: "95px" }}></div>
                        <Button variant="primary" type="submit" className="btn-submit">
                            {this.props.match.params.id ? "Update" : "Add"}
                        </Button>
                        <div>
                            {deleteButton}
                        </div>
                    </div>
                </Form>
            </div >
        );
    }
}

export default AddPas;

